import { useState, useEffect, useRef, useMemo } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { toast } from 'react-toastify'
import { FaTimes, FaFileExport } from "react-icons/fa";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Server from "../../Shared/Server"
import Spinner from '../../Shared/Spinner'
import BackButton from '../../Shared/BackButton'
import { InputField } from "../../Shared/InputField";
import {AgGridReact} from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

const AccountPayableDetail = () => {
    const [data, setData] = useState([])
    const [pinnedBottomRowData, setPinnedBottomRowData] = useState([]);
    const [isLoading, setIsLoading] = useState(false)
    const [title, setTitle] = useState('')
    const [errors, setErrors] = useState({})
    const [publicID, setPublicID] = useState({})
    const [show, setShow] = useState(false);
    const [formData, setFormData] = useState({
        public_id: "",
        vendor: "",
        fdate: new Date().toISOString().slice(0, 10),
        tdate: new Date().toISOString().slice(0, 10),
    });
    const {public_id, vendor, fdate, tdate} = formData;


    const gridRef = useRef();
    const navigate = useNavigate()
    const location = useLocation()

    const fetchData = async (payload) => {
        setIsLoading(true)
        try {
            const response = await Server.get(`/account-payable/${payload.public_id}?fdate=${payload.fdate}&tdate=${payload.tdate}`)
            setData(response?.data)
            setIsLoading(false) 

            const output = response?.data.reduce((data, row) => {
                data.debit += parseFloat(row.debit);
                data.credit += parseFloat(row.credit);
                return data;
            }, {debit: 0.00, credit: 0.00, balance: 0.00});
            setPinnedBottomRowData([
                {
                    debit: parseFloat(output.debit).toFixed(2),
                    credit: parseFloat(output.credit).toFixed(2),
                    balance: (output.credit - output.debit).toFixed(2)
                }
            ]);
        } catch (error) {
            setIsLoading(false)
            if(error.response.status === 401){
                localStorage.removeItem('user')
                navigate('/login')
            }else if (error.response.status === 403){
                toast.error(error.response.data.detail);
                navigate('/');
            }else {
                toast.error(error?.response?.data?.detail)
            }
        }
    }

    useEffect(() => {
        if(location.state) {
            const {payload} = location.state
            setFormData((prev) => ({
                ...prev,
                public_id: payload.public_id,
                vendor: payload.vendor,
            }))
            fetchData({fdate, tdate, public_id: payload.public_id})
            setTitle(`${payload.vendor} Account Payable Details From ${fdate} To ${tdate}`)
        }
        
    }, [])

    const handleClose = () => {
        setShow(false)
    }
    const handleShow = (public_id) => {
        setShow(true)
        setPublicID(public_id)
    };

    const handleDelete = async (public_id) => {
        setShow(false)
        try {
            setIsLoading(true)
            const response = await Server.delete(`/vendors/${public_id}/statement`)
            toast.success(response.data.detail)
            setData(data.filter((report) => report.public_id !== public_id))
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false)
            if(error.response.status === 401){
                navigate('/login')
            }else if (error.response.status === 403){
                toast.error(error.response.data.detail);
                navigate('/');
            }else{
                toast.error(error.response.data?.detail)
            }
        }
    }

    const onChange = (e) => {
        setFormData((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value
        }))
    }
    
    const onSubmit = (e) => {
        e.preventDefault()

        fetchData({fdate, tdate, public_id})
        setTitle(`${vendor} Account Payable Details From ${fdate} To ${tdate}`)
    }
    
    const defaultColDef = useMemo(() => {
        return {
            filterParams: {
                buttons: []
            }
        };
    }, []);

    const onFirstDataRendered = (params) => {
        params.api.autoSizeAllColumns();
    }

    const onGridSizeChanged = (params) => {
        params.api.autoSizeAllColumns();
    }

    let gridApi

    const onGridReady=(params)=>{
        gridApi=params.api
    }
      const onExportClick=()=>{
        gridApi.exportDataAsCsv({ fileName: `${title}.csv` })
    }

    if(isLoading){
        return <Spinner/>
    }

    const getRowStyle = (params) => {
        if (params.node.rowPinned) {
          return {
            backgroundColor: '#f8f9fa',
            fontWeight: 'bold',
            color: '#000',
          };
        }
        return {};
    };

  return (
    <>
        <div className="row">
            <div className="col-md-12">
                <BackButton
                    to="/account-payable"
                    state={{ fdate: location.state?.payload?.fdate, tdate: location.state?.payload?.tdate, by: location.state?.payload?.by }}
                    label="Back to Summary"
                />
            </div>
        </div>
        <form onSubmit={onSubmit}>
            <div className="row">
                <div className="col-md-2">
                    <InputField
                        name="fdate"
                        type="date"
                        required="required"
                        value={fdate}
                        onChange={onChange}
                        error={errors.fdate}
                    />
                </div>
                <div className="col-md-2">
                    <InputField
                        name="tdate"
                        type="date"
                        required="required"
                        value={tdate}
                        onChange={onChange}
                        error={errors.tdate}
                    />
                </div>
                <div className="col-md-7">
                    <input type="submit" className="btn btn-info mt-1" value="Apply Filter" style={{float: 'left'}}/>
                </div>
                <div className="col-md-1">
                    <button onClick={()=>onExportClick()} className="btn btn-success mb-2" style={{float: 'right'}}><FaFileExport/> &nbsp;Export</button>
                </div>
            </div>
            <br/>
        </form>
        <div className="card mt-0">
            <div className="card-header p-2 bg-info text-white d-flex justify-content-center">
                    <h3 className="card-title">{title}</h3>
            </div>
            <div className="card-body">
                <div className="row">
                    <div className="col-md-12">
                        <div className="ag-theme-alpine responsive-aggrid" style={{ height: 400, width: '100%' }}>
                        <AgGridReact
                            defaultColDef={defaultColDef}
                            onFirstDataRendered={onFirstDataRendered}
                            onGridSizeChanged={onGridSizeChanged}
                            suppressMenuHide={true}
                            
                            rowData={data}
                            domLayout={"normal"}
                            rowSelection={"multiple"}
                        
                            pagination={false}
                            onGridReady={onGridReady}
                        
                            resizable={true}
                            animateRows={true}
                            enableCellTextSelection={true}
                            suppressCellFocus={true}
                        
                        
                            ref={gridRef}
                            pinnedBottomRowData={pinnedBottomRowData}
                            getRowStyle={getRowStyle}
                            columnDefs={[
                            {
                                headerName: "#",
                                filter: false,
                                maxWidth: 70,
                                sortable: true,
                                valueFormatter: function (params) {
                                if (isNaN(params.node.id)) {
                                    return "";
                                }
                                return `${Number(params.node.rowIndex) + 1}`;
                                },
                            },
                            {
                                headerName: "Date",
                                field: "date",
                                sortable: true,
                                filter: 'agDateColumnFilter',
                                filterParams: {
                                    comparator: (filterDate, cellValue) => {
                                      const cellDate = new Date(cellValue);
                                      cellDate.setHours(0, 0, 0, 0);
                                      filterDate.setHours(0, 0, 0, 0);
                            
                                      if (cellDate < filterDate) return -1;
                                      if (cellDate > filterDate) return 1;
                                      return 0;
                                    },
                                },
                            },
                            {
                                headerName: "User",
                                field: "user",
                                sortable: true,
                                filter: true,
                            },
                            {
                                headerName: "Remark",
                                field: "remark",
                                sortable: true,
                                filter: true,
                            },
                            {
                                headerName: "Opening",
                                field: "opening_balance",
                                sortable: true,
                                filter: 'agNumberColumnFilter',
                                cellDataType: "number",
                                valueParser: (params) => {
                                    const parsedValue = parseFloat(params.newValue);
                                    return isNaN(parsedValue) ? null : parsedValue;
                                    },
                                valueFormatter: (params) => params.value != null ? `${params.value}` : 0.00
                            },
                            {
                                headerName: "Credit",
                                field: "credit",
                                sortable: true,
                                filter: 'agNumberColumnFilter',
                                cellDataType: "number",
                                valueParser: (params) => {
                                    const parsedValue = parseFloat(params.newValue);
                                    return isNaN(parsedValue) ? null : parsedValue;
                                    },
                                valueFormatter: (params) => params.value != null ? `${params.value}` : 0.00
                            },
                            {
                                headerName: "Debit",
                                field: "debit",
                                sortable: true,
                                filter: 'agNumberColumnFilter',
                                cellDataType: "number",
                                valueParser: (params) => {
                                    const parsedValue = parseFloat(params.newValue);
                                    return isNaN(parsedValue) ? null : parsedValue;
                                    },
                                valueFormatter: (params) => params.value != null ? `${params.value}` : 0.00
                            },
                            {
                                headerName: "Balance",
                                field: "balance",
                                sortable: true,
                                filter: 'agNumberColumnFilter',
                                cellDataType: "number",
                                valueParser: (params) => {
                                    const parsedValue = parseFloat(params.newValue);
                                    return isNaN(parsedValue) ? null : parsedValue;
                                    },
                                valueFormatter: (params) => params.value != null ? `${params.value}` : 0.00
                            },
                            {
                                headerName: "Cancel",
                                cellRenderer: (e) => { 
                                    if (e.node.rowPinned) return ''; // do not display button on rowPinned
                                    if (e.data.remark === "Opening Balance") return '';
                                    return <button className="btn btn-outline-danger" onClick={()=> handleShow(e.data.public_id)}><FaTimes/></button>
                                },
                                sortable: false,
                                filter: false,
                            },
                            ]}
                        ></AgGridReact>{" "}
                    </div>
                    </div>
                </div>
            </div>
        </div>
        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Delete Alert</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure?</Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={handleClose}>
              No
            </Button>
            <Button variant="danger" onClick={() => handleDelete(publicID)}>
              Yes
            </Button>
          </Modal.Footer>
        </Modal>
      <br/>
    </>
  )
}

export default AccountPayableDetail